import React, { Component } from "react"; 
import "bootstrap/dist/css/bootstrap.min.css";
import PrimeReact from "primereact/utils"; 

import "./styles/index.scss";
import "./styles/index-mobile.scss";
import "primeflex/primeflex.css";
import { AppHeader, AppContainer, AppFooter } from "./components/Layout";

class App extends Component {
  constructor(props) {
    super(props);
    // Activate ripple on buttons.
    PrimeReact.ripple = true;
  }

  render() {
    return (
      <div className="box">
       <AppHeader/>
       <AppContainer props={this.props} /> 
       <AppFooter />
      </div>
    );
  }
}

export default App;
